import React, { useEffect, useState } from 'react'
import Proxies from '../../components/proxies'
import DynamicTable from 'Components/dynamicTable'
import CollapsibleCard from 'Components/collapsibleCard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { Button, ButtonGroup, Modal, ModalHeader, Tooltip } from 'reactstrap'
import moment from 'moment'

const ChristmasCalendarOverview = () => {
  const [christmasCalendars, setChristmasCalenders] = useState([])
  const [loading, setLoading] = useState(false)
  const [christmasCalendarFilterValue, setchristmasCalendarFilterValue] = useState('active')
  const [modelOpen, setModalOpen] = useState(false)

  useEffect(() => {
    setLoading(true)
    getChristmasCalendars()
  }, [])

  function getChristmasCalendars() {
    Proxies.GET('competitionv2/pool', { type: 'CHRISTMAS_CALENDAR' }).then(responseJSON => {
      if (responseJSON.error) {
        // console.log(responseJSON.error)
      } else {
        setChristmasCalenders(responseJSON)
      }
      setLoading(false)
    })
  }

  function RemoveChristmasCalendar(CompetitionID) {
    Proxies.POST('competitionv2/removeComp', { CompetitionID: Number(CompetitionID) }).then(responseJSON => {
      if (responseJSON.error) {
        // console.log(responseJSON.error)
      } else {
        getChristmasCalendars()
      }
    })
  }

  return (
    <>
      <CollapsibleCard
        startOpen
        header={
          <strong>
            Julekalendere
            <Button tag={Link} to={'christmas-calendar/new'} style={{ marginLeft: '16px' }}>
              Opret ny
            </Button>
            <ButtonGroup className='float-right'>
              <Button
                outline
                color='success'
                onClick={() => setchristmasCalendarFilterValue(christmasCalendarFilterValue === 'active' ? 'both' : 'active')}
                active={christmasCalendarFilterValue === 'active'}
              >
                Active
              </Button>
              <Button
                outline
                color='danger'
                onClick={() => setchristmasCalendarFilterValue(christmasCalendarFilterValue === 'inactive' ? 'both' : 'inactive')}
                active={christmasCalendarFilterValue === 'inactive'}
              >
                In-Active
              </Button>
            </ButtonGroup>
          </strong>
        }
      >
        {loading ? (
          <FontAwesomeIcon icon='spinner' spin />
        ) : (
          <DynamicTable
            responsive
            size='sm'
            options={{
              startSort: {
                dir: 'DESC',
                column: 'name'
              },
              fieldFunctions: {
                startDate: e => {
                  return moment(e.startDate).format('DD-MM-YYYY')
                },
                endDate: e => {
                  return moment(e.endDate).format('DD-MM-YYYY')
                },
                status: e => {
                  let s
                  if (e.status === 'READY') {
                    s = 'DRAFT'
                  } else if (e.status === 'STARTED') {
                    s = 'PUBLISHED'
                  } else {
                    s = e.status
                  }
                  return s
                }
              },
              addField: e => {
                return (
                  <td>
                    <ButtonGroup>
                      <Tooltip target={'view' + e.CompetitionID}>Vis</Tooltip>
                      <Button
                        tag={Link}
                        to={{ pathname: '/christmas-calendar/' + e.CompetitionID + '/view', state: e }}
                        id={'view' + e.CompetitionID}
                      >
                        <FontAwesomeIcon icon='eye' />
                      </Button>
                      <Button
                        onClick={() => {
                          e.status === 'ENDED' && setModalOpen(true)
                        }}
                        tag={Link}
                        to={e.status !== 'ENDED' && '/christmas-calendar/' + e.CompetitionID}
                        id={'edit' + e.CompetitionID}
                      >
                        <FontAwesomeIcon icon='edit' />
                      </Button>
                      <Button
                        id={'delete' + e.CompetitionID}
                        color='danger'
                        onClick={() => {
                          if (confirm('Are you sure you want to delete?')) {
                            RemoveChristmasCalendar(e.CompetitionID)
                          }
                        }}
                      >
                        <FontAwesomeIcon icon='trash' />
                      </Button>
                    </ButtonGroup>
                  </td>
                )
              }
            }}
            headers={{
              CompetitionID: '#',
              title: 'Title',
              detailDescription: 'Beskrivelse',
              startDate: 'Aktiveringsdato',
              endDate: 'Deaktiveringsdato',
              status: 'Status'
            }}
            data={
              christmasCalendars && christmasCalendarFilterValue !== 'both' && !!christmasCalendars.length
                ? christmasCalendars.filter(christmasCalendar => christmasCalendar.removed === (christmasCalendarFilterValue === 'inactive' ? 1 : 0))
                : christmasCalendars
            }
          />
        )}
      </CollapsibleCard>
      <Modal className='customization__modal' isOpen={modelOpen}>
        <ModalHeader toggle={() => setModalOpen(!modelOpen)}>Julekalender er allerede sluttede</ModalHeader>
      </Modal>
    </>
  )
}

export default ChristmasCalendarOverview
